// The organizer's Direct Link carries a key (`key=` in the link). A checkout
// that sends the event's key is not stopped by the event's cap. The key is
// remembered per event for this browser tab, so it survives the steps
// between opening the link and paying.
const storageKey = (eventId) => `directLinkKey:${eventId}`;

export const rememberDirectLinkKey = (search) => {
  const params = new URLSearchParams(search || "");
  const eventId = params.get("id");
  const key = params.get("key");
  if (!eventId || !key) return;
  try {
    sessionStorage.setItem(storageKey(eventId), key);
  } catch (_) { }
};

export const directLinkKeyFor = (eventId) => {
  if (!eventId) return undefined;
  try {
    return sessionStorage.getItem(storageKey(eventId)) || undefined;
  } catch (_) {
    return undefined;
  }
};
